import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../usercomponents/SideBar';
import TopNavBar from '../usercomponents/TopNavBar';
import Footer from '../usercomponents/Footer';

const apiUrl = process.env.REACT_APP_API_URL;

function formatDateTime(v) {
  if (!v) return '—';
  return new Date(v).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

function MockExamHistory() {
  const navigate = useNavigate();
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const getToken = () => JSON.parse(sessionStorage.getItem('studentSession'))?.token;

  const fetchHistory = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const token = getToken();
      const response = await axios.get(`${apiUrl}/api/student/mock-exams/history`, { headers: { Authorization: `Bearer ${token}` } });
      if (response.data.success) setAttempts(response.data.attempts || []);
      else setError(response.data.message || 'Failed to load history.');
    } catch (err) {
      setError(err.response?.data?.message || 'Error loading history.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchHistory(); }, [fetchHistory]);

  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body px-3">
          <div className="breadcrumb mb-24">
            <ul className="d-flex align-items-center gap-2 list-unstyled">
              <li><Link to="/mock-exams" className="text-gray-200 text-15 hover-text-main-600 text-decoration-none">Mock Exams</Link></li>
              <li><span className="text-gray-500 d-flex align-items-center"><i className="ph ph-caret-right" /></span></li>
              <li><span className="text-main-600 text-15">My Exam History</span></li>
            </ul>
          </div>

          {error && <div className="alert alert-danger mb-20">{error}</div>}

          <div className="card shadow-sm border-0">
            <div className="card-body p-0">
              {loading ? (
                <div className="text-center py-40"><div className="spinner-border text-main-600" /></div>
              ) : attempts.length === 0 ? (
                <div className="text-center py-40 text-gray-400">No mock exam attempts yet.</div>
              ) : (
                <div className="table-responsive">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th>Exam</th><th>Course</th><th>Attempt #</th><th>Date</th><th>Marks</th><th>Result</th><th>Status</th><th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {attempts.map((a) => (
                        <tr key={a.id}>
                          <td className="fw-semibold">{a.exam_title}</td>
                          <td>{a.coursename}</td>
                          <td>{a.attempt_number}</td>
                          <td>{formatDateTime(a.started_at)}</td>
                          <td>{a.total_marks_scored !== null ? `${a.total_marks_scored} / ${a.total_marks_possible}` : '—'}</td>
                          <td>
                            {a.pass_fail ? (
                              <span className={`badge ${a.pass_fail === 'pass' ? 'bg-success-subtle text-success-emphasis' : 'bg-danger-subtle text-danger-emphasis'}`}>{a.pass_fail}</span>
                            ) : '—'}
                          </td>
                          <td><span className="badge bg-neutral-200 text-neutral-600">{a.status.replace('_', ' ')}</span></td>
                          <td>
                            <button type="button" className="btn btn-sm btn-outline-main py-4 px-8" onClick={() => navigate(`/mock-exam-result/${a.id}`)}>View</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default MockExamHistory;
